import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TitleStyled = styled.h3`
  ${typography.bold[24]};
  color: ${colors.neutral[900]};
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  padding-bottom: 1.5rem;
  margin: 0 0 1rem;

  /* Useful when the title is inside an IMForm */
  width: 100%;
`;
